import { render, staticRenderFns } from "./ModalUnsubscribe.vue?vue&type=template&id=363c3e8a&scoped=true&"
import script from "./ModalUnsubscribe.vue?vue&type=script&lang=js&"
export * from "./ModalUnsubscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363c3e8a",
  null
  
)

export default component.exports